export default {
	// Profile (page)
	Profile_headerText: "My Profile",

	// Personal Info form
	PersonalInfo_preferredName_hint: "Your preferred name or nickname to be used throughout Teaming.",
	PersonalInfo_preferredName_label: "Preferred name",
	PersonalInfo_preferredName_invalidError: "Preferred name must be less than 200 characters in length.",
	PersonalInfo_title_hint: "Your role on the team.",
	PersonalInfo_title_label: "Title",
	PersonalInfo_title_invalidError: "Title must be less than 200 characters in length.",
	PersonalInfo_location_hint: "In which office/branch/city are you located?",
	PersonalInfo_location_label: "Location",
	PersonalInfo_location_invalidError: "Location must be less than 200 characters in length.",
	PersonalInfo_bio_hint: "Tell the team something fun and interesting about yourself.",
	PersonalInfo_bio_label: "Bio",
	PersonalInfo_bio_invalidError: "Bio must be less than 500 characters in length.",
	PersonalInfo_clear_button: "Clear Changes",
	PersonalInfo_save_button: "Save Changes",
	PersonalInfo_signInBy_text: "sign-in managed by {signInProvider}",

	// Assessment
	Assessment_title_text: "Your Work Style",
	Assessment_subtitle_text: "Gain valuable insights into your team’s work and communication styles by taking a brief, 10-minute assessment.",
	Assessment_start_button: "Take the assessment",

	// Assessment Dialog
	AssessmentDialog_header: "Work Style Assessment",

	// DiscProfile
	DiscProfile_headerText: "Your Work Style",

	// WorkStyleLabel
	WorkStyleLabel_notTakenText: "Not Taken",

	// routes
	routes_profile_title: "Me",

	// store
	PersonalInfo_saveUserProfileSuccessMessage: "Successfully saved user profile",
	PersonalInfo_saveUserProfileErrorMessage: "An unexpected error occurred while saving your user profile: {error}",
	PersonalInfo_loadUserProfileErrorMessage: "An unexpected error occurred while loading your user profile: {error}",
	PersonalInfo_calPermsWrongAccountErrorMessage: "You are signed in as {email}, but you attempted to authorize calendar permissions for {targetEmail}. Please try again and select {email}.",
	AssessmentDialog_saveUserAssessmentSuccessMessage: "Successfully saved work style results",
	AssessmentDialog_saveUserAssessmentErrorMessage: "An unexpected error occurred while saving your work style results: {error}",
	DiscProfile_behaviorSectionHeader: "What comes naturally to {person}",
	DiscProfile_motivationsSectionHeader: "What energizes {person}",
	DiscProfile_drainsSectionHeader: "What drains {person}",

	//
	// UserSettings
	//
	UserSettings_cancelAccountTitle: "Cancel Your Teaming Account",
	UserSettings_cancelAccountDescription1: "We will be sad to see you go but we'll make the process as quick as possible.",
	UserSettings_cancelAccountDescription2: "To cancel your account, click 'Cancel my account' and then confirm.",
	UserSettings_cancelAccountAdminRoleWarning: "You must assign Admin role to another or cancel the Team Account.",
	UserSettings_cancelAccountButton: "Cancel my account",

	UserSettings_cancelAccountPromptTitle: "Before You Go!",
	UserSettings_cancelAccountPromptDescription1: "We would love to know why are you leaving. Feedback is essential to improvement, please let us know what we can do better by letting us know why you are leaving.",
	UserSettings_cancelAccountPromptDescription2: "Please select the reasons you are cancelling your account.",
	UserSettings_cancelAccountPromptDescription3: "Any advice on how we could have made your experience with Teaming better?",
	UserSettings_cancelAccountPromptCancelButton: "I changed my mind",
	UserSettings_cancelAccountPromptConfirmButton: "Confirm account cancellation",
	UserSettings_cancelAccountPromptManagerError: "You must assign Admin role to another or cancel the Team Account",

	UserSettings_cancelAccountPromptReason0: "Too expensive",
	UserSettings_cancelAccountPromptReason1: "Too many technical issues",
	UserSettings_cancelAccountPromptReason2: "Too difficult to use or understand",
	UserSettings_cancelAccountPromptReason3: "Not the tool I was expecting",
	UserSettings_cancelAccountPromptReason4: "Missing needed features",
	UserSettings_cancelAccountPromptReason5: "Switching to another product",
	UserSettings_cancelAccountPromptReason6: "Could not get my team to use it",
	UserSettings_cancelAccountPromptReason7: "Wasn't getting enough value",
	UserSettings_cancelAccountPromptReason8: "No longer have a team",
	UserSettings_cancelAccountPromptReason9: "Never got around to actually trying it",

	UserSettings_cancelAccountPromptValidationError: "Please select one or more cancellation reasons.",

	UserSettings_cancelAccountConfirmationTitle: "Thank you for trying Teaming!",
	UserSettings_cancelAccountConfirmationDescription1: "We are sad to see you go but hope you will consider trying Teaming again in the future. We are working hard to make Teaming better every day!",
	UserSettings_cancelAccountConfirmationDescription2: "Your account will remain active for the next 24 hours to ensure you have time to gather any data that you will need in the future.",
	UserSettings_cancelAccountConfirmationOKButton: "Ok",

	UserSettings_cancelAccountPendingCancellationMessage: "Your account is awaiting cancellation. It will remain active for the next 24 hours to ensure you have time to gather any data that you will need in the future.",
};



// WEBPACK FOOTER //
// ./src/lang/en/profile.js